export class MigrationRoutingInfo {
  routes?: RouteInfo[];

  constructor(init?: Partial<MigrationRoutingInfo>) {
    Object.assign(this, init);
  }
}

export class RouteInfo {
  name?: string;
  fromActivity?: string;
  toActivity?: string;
  logicalOperator?: string; // AND or OR
  conditions?: RouteConditionInfo[];

  constructor(init?: Partial<RouteInfo>) {
    Object.assign(this, init);
  }
}

export class RouteConditionInfo {
  field?: string;
  operator?: string;
  value?: string;

  constructor(init?: Partial<RouteConditionInfo>) {
    Object.assign(this, init);
  }
}
